<header class="topbar">
  <div class="topbar__left">
    @if (breadcrumbs().length) {
      <nav class="topbar__breadcrumb" aria-label="Breadcrumb">
        @for (crumb of breadcrumbs(); track crumb.label; let last = $last) {
          <span class="topbar__crumb">{{ crumb.label }}</span>
          @if (!last) { <span class="topbar__crumb-sep">/</span> }
        }
      </nav>
    }
    @if (title()) {
      <h1 class="topbar__title">{{ title() }}</h1>
    }
  </div>

  <div class="topbar__right">
    <label class="topbar__search">
      <span class="topbar__search-icon" aria-hidden="true">🔍</span>
      <input
        type="search"
        class="topbar__search-input"
        placeholder="Search..."
        [ngModel]="searchQuery()"
        (ngModelChange)="searchQuery.set($event)"
      />
    </label>

    <button type="button" class="topbar__icon-btn" aria-label="Settings">⚙</button>

    <button type="button" class="topbar__avatar" aria-label="Account">
      {{ userInitials() }}
    </button>
  </div>
</header>
